import Service from '../Service'
import {http} from '../config'

export default class AutenticadorService extends Service{

  constructor(){
    super('autenticador');
  }

  AutenticarUsuario(usuario){
    return http.post(`${this.getNomeControle()}/Usuario`, usuario);
  }
}